import { Button } from "@mui/material"
import { FC, useEffect, useMemo, useState } from "react"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { EArchType, gdsPlusSetup, toothMovement, wasmModule } from "@/gluelayer"
import MyDialog from "@/shared/components/MyDialog"
import { EArchForm, ESteupModelType } from "@/shared/types"
import { setOpenInitialFinal } from "@/UDTreat/udTreatSlice"
import ClassNames from "classnames"

interface IProps {
  curArch: string
  type: EArchForm | null
  setType: (type: EArchForm | null) => void
  setExpanded: (type: ESteupModelType | null) => void
}

const ArchForm: FC<IProps> = ({ curArch, type, setType, setExpanded }) => {
  const dispatch = useAppDispatch()
  const [open, setOpen] = useState(false)
  const {
    openBiteCheck,
    openInitialFinal,
    openCollisionCheck,
    switchViewEdit,
  } = useAppSelector((state: RootState) => state.udTreatService)

  /**
   * Arch Form
   */
  const initeView = (initStatus: boolean) => {
    // if (!initStatus) {
    //   dispatch(setDisabledBiteCheck(false))
    //   dispatch(setOpenBiteCheck(true))
    // } else {
    //   dispatch(setDisabledBiteCheck(true))
    //   dispatch(setOpenBiteCheck(false))
    // }
    setType(null)
    if (!wasmModule.isFinishedOpencase) return
    toothMovement.switchModuleFineTuneCircle(false)
    toothMovement.switchModuleFastSmartCircle(false)
    gdsPlusSetup.onlyEnterIPREditMode(true)
  }

  useEffect(() => {
    initeView(true)
    return () => {
      initeView(false)
    }
  }, [])

  // 监听牙弓是否开启
  const disabled = useMemo(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (hasUpper && hasLower && curArch === "all") {
      return true
    } else {
      return false
    }
  }, [
    wasmModule.getArchModel(EArchType.UpArch),
    wasmModule.getArchModel(EArchType.LowArch),
    curArch,
  ])

  useEffect(() => {
    if (disabled) {
      setType(null)
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }, [disabled])

  const handleAlignment = (type: EArchForm | null) => {
    if (!wasmModule.isFinishedOpencase) return
    if (type === null) {
      setType(type)
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
      gdsPlusSetup.onlyEnterIPREditMode(true)
      return
    }
    // 开启Initial Final 模式时，关闭牙弓
    if (openInitialFinal) {
      dispatch(setOpenInitialFinal(false))
    }
    if (disabled) {
      setOpen(true)
      return
    }

    setType(type)
    gdsPlusSetup.onlyEnterIPREditMode(false)

    if (type === EArchForm.FASTSMART) {
      // if (openBiteCheck) {
      // dispatch(setOpenBiteCheck(false))
      // viewControlInTreatment.setOcclusionVisibility(false)
      // }

      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(true)
    } else if (type === EArchForm.FINETUNE) {
      // if (openBiteCheck) {
      // dispatch(setOpenBiteCheck(false))
      // }
      // viewControlInTreatment.setOcclusionVisibility(false)
      toothMovement.switchModuleFastSmartCircle(false)
      toothMovement.switchModuleFineTuneCircle(true)
    } else {
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }

  return (
    <>
      <div className="card-item-body content-space">
        <Button
          className={ClassNames("btn w-100", {
            "btn-secondary my-btn-secondary ":
              !type || type !== EArchForm.FASTSMART,
          })}
          variant="contained"
          onClick={() => {
            let currentType = EArchForm.FASTSMART
            if (type === currentType) {
              currentType = null
            }
            handleAlignment(currentType)
          }}
        >
          Arch Adjustment
        </Button>
        <Button
          className={ClassNames("btn w-100", {
            "btn-secondary my-btn-secondary ":
              !type || type !== EArchForm.FINETUNE,
          })}
          variant="contained"
          onClick={() => {
            let currentType = EArchForm.FINETUNE
            if (type === currentType) {
              currentType = null
            }
            handleAlignment(currentType)
          }}
        >
          Vertical Adjustment
        </Button>
      </div>

      <MyDialog
        open={open}
        content="Please select a single arch to use this function."
        cancelText="OK"
        onClose={() => setOpen(false)}
      />
    </>
  )
}

export default ArchForm
